import React, { useState, useEffect } from "react";
import "./App.css";
import Hashloader from "react-spinners/HashLoader";
import Banner from "./components/Banner";
import Nav from "./components/Nav";
import Services from "./components/Services";
import About from "./components/About";
import Contact from "./components/Contact";

import Footer from "./components/Footer";

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

function App() {
  const [loading, setLoading] = useState(true);
  const [color, setColor] = useState("#1f2235");

  useEffect(() => {
    // simulate data loading
    setTimeout(() => {
      setLoading(false);
    }, 2500);
  }, []);

  return (
    <>
      {loading ? (
        <div className="spinerStyle">
          <Hashloader
            cssOverride={override}
            loading={loading}
            color={color}
            size={80}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </div>
      ) : (
        <div>
          <>
            <Nav />

            <Banner />
            <Services />
            <About />

            <Contact />
            <Footer />
          </>
        </div>
      )}
    </>
  );
}

export default App;
